"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapseToggle = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const index_1 = require("../../index");
const hooks_1 = require("../../../hooks");
/** Provides a chevron icons to collapse/un-collapse for parent/child tables. */
function CollapseToggle(props) {
    const { row, compact } = props;
    const { tableState } = (0, react_1.useContext)(index_1.TableStateContext);
    const isCollapsed = (0, hooks_1.useComputed)(() => tableState.isCollapsed(row.id), [tableState]);
    const iconKey = isCollapsed ? "chevronRight" : "chevronDown";
    const headerIconKey = isCollapsed ? "chevronsRight" : "chevronsDown";
    // If we're not a header, only render a toggle if we have child rows to actually collapse
    const isHeader = row.kind === "header";
    if (!isHeader && (!row.children || row.children.length === 0)) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(index_1.IconButton, { onClick: () => tableState.toggleCollapsed(row.id), icon: isHeader ? headerIconKey : iconKey, compact: compact }));
}
exports.CollapseToggle = CollapseToggle;
